import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loadPatients()
  }

  async loadPatients() {
    try {
      const response = await fetch(this.urlValue)
      const data = await response.json()

      // Clear existing options except the first one
      this.element.innerHTML = '<option value="">Select a patient visit...</option>'

      // Group visits by patient
      const patientVisits = {}
      data.visits.forEach(visit => {
        const patient = visit.patient
        const key = `${patient.first_name} ${patient.last_name}`
        if (!patientVisits[key]) {
          patientVisits[key] = []
        }
        patientVisits[key].push(visit)
      })

      // Add optgroups for each patient
      Object.keys(patientVisits).sort().forEach(patientName => {
        const optgroup = document.createElement('optgroup')
        optgroup.label = patientName

        patientVisits[patientName].forEach(visit => {
          const option = document.createElement('option')
          option.value = visit.id
          option.textContent = `${this.formatDate(visit.appointment_date)} - ${visit.status || 'Scheduled'}`
          optgroup.appendChild(option)
        })

        this.element.appendChild(optgroup)
      })

    } catch (error) {
      console.error('Error loading patients:', error)
      this.element.innerHTML = '<option value="">Error loading patients</option>'
    }
  }

  formatDate(dateString) {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }
}